/**
 * Google Drive file ID からプレビュー URL を組み立てる。
 *
 * 物件図面 PDF は Google Drive 上に保存されており、
 * `property_sale_histories.floor_plan_path` には Drive file ID が入っている。
 *
 * 既存データとの互換性のため、以下は Drive file ID ではないと判定して null を返す:
 * - `http://` / `https://` で始まる値（失効済み REINS 生 URL 等の遺物）
 * - スラッシュを含む値（`url/xxx.pdf` 形式の旧ローカルパス）
 * これにより壊れた Drive URL を生成せず、フロントは "N/A" を表示できる。
 *
 * @param fileId Google Drive の file ID。null / undefined / 空文字列等の場合は null を返す
 * @returns `https://drive.google.com/file/d/{fileId}/view` または null
 */
export const buildDrivePreviewUrl = (
  fileId: string | null | undefined,
): string | null => {
  if (!fileId) {
    return null;
  }
  const trimmed = fileId.trim();
  if (trimmed === "") {
    return null;
  }
  // http(s) URL は Drive file ID ではない（失効済み REINS URL 等の遺物）
  if (/^https?:\/\//i.test(trimmed)) {
    return null;
  }
  // スラッシュを含む値は Drive file ID ではない（url/xxx.pdf 等の旧ローカルパス）
  if (trimmed.includes("/")) {
    return null;
  }
  return `https://drive.google.com/file/d/${encodeURIComponent(trimmed)}/view`;
};
